import { Grid } from '@material-ui/core'
import styled from 'styled-components/macro'

export const Container = styled(Grid)` 
    ::-webkit-scrollbar {
    width: 6px;
    }

    ::-webkit-scrollbar-track {
    background: transparent;
    }

    ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 10px;
    }

    /* Estilo para navegadores como Firefox */
    * {
    scrollbar-width: thin;
    scrollbar-color: #ccc transparent;
    }

      
    .MuiIconButton-colorPrimary:hover,
    .MuiIconButton-root:hover {
        background-color: transparent !important;
    }

    .form-container-inner {
        max-width:  800px important;
        overflow-y:  auto;
        height:  100vh;
    }

    @media (max-width: 960px) {
        .form-container-inner { 
            overflow-y: hidden;
            height: 100%; 
        } 
    }
`

export const GridBox = styled(Grid)` 
    b {
        color: #1f1f1f;
    }

    .MuiGrid-spacing-xs-2 {
        margin: 0;
    }

    @media screen and (min-width: 960px) {
        &.MuiGrid-item {
            margin-top: 0.7rem;
        }
    }

    @media screen and (min-width: 1200px) {
        &.MuiGrid-grid-xs-12 {
            max-width: 90%;
            margin: 0 auto;
        }
    }

    @media screen and (min-width: 1460px) {
        &.MuiGrid-grid-xs-12 {
            max-width: 75%;
        }
    }
`

export const ButtonBox = styled(Grid)`
    p {
        margin: 0;
        color: #1f1f1f;
        font-size: 15px;
        text-align: center;
    }

    > .MuiGrid-item {
        margin-top: 1rem;

        button {
            width: 100%;
            height: 36px;
            border-radius: 8px;
        }
    }
`

export const ErrorBox = styled.div`
    .mt-2 {
        margin-top: 20px;
    }
    a,
    span {
        font-size: 14px;
        font-weight: 700;
        color: ${({ themeColor }) =>
        themeColor?.navigation?.buttons?.backgroundColor || ''};
    }
    .MuiTypography-body1 {
        color: rgba(0, 0, 0, 0.87);
        font-size: 14px;
        font-weight: 300;
    }
    .error {
        .MuiTypography-body1 {
            color: #f44336;
        }
    }
    .MuiFormGroup-root {
        flex-direction: row;
    }
`
